module.exports = __webpack_public_path__ + "img/health13_7-9-2021.bb74be91.jpg";